module.exports = __webpack_public_path__ + "media/images/lb/111-7eb61ec328c587e32cacfc7256a8d86d.svg";